<template>
  <div class="h-100">
    <vis-toolbar :items="toolbar" class="vis-grid-toolbar" />

    <!-- TODO: remove extra divs, they needed due to styles in _admin-panel.scss -->
    <div>
      <div>
        <vis-base-grid
          class="vis-has-toolbar"
          :columns="gridColumns"
          :dataSource="dataSource"
          @select="onSelect"
        />
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/visary-api";
import ArrayStore from 'devextreme/data/array_store';

export default {
  name: "vis-cache-grid-view",
  data(vm) {
    return {
      selectedItems: [],
      gridColumns: [
        {
          field: "Title",
          type: "String",
          title: "Название"
          // width: 200
        }
      ],
      toolbar: [
        {
          id: "buttons",
          type: "button-group",
          buttons: [
            {
              id: "clear",
              icon: "far fa-trash",
              title: vm.$t("toolbar.button.clear"),
              disabled: true,
              async onClick() {
                await Promise.all(
                  vm.selectedItems.map(async item => {
                    try {
                      await api.administration.clearCache(item.ID);
                      vm.$visNotification.success(
                        `${item.Title} сброшен.`
                      );
                    } catch (err) {
                      vm.$visNotification.error(
                        `${item.Title} не сброшен. Ошибка: ${err.message}`
                      );
                    }
                  })
                );
              },
              updateState() {
                this.disabled = Object.keys(vm.selectedItems).length === 0;
              }
            },
            {
              icon: "fal fa-question",
              type: "vis-mnemonic-help-toolbar-button",
              mnemonic: "CacheAdministrationHelpFile",
              title: this.$t("toolbar.button.Help"),
            }
          ]
        }
      ],
      dataSource: null
    };
  },
  methods: {
    onSelect(event) {
      this.selectedItems = event.items;
      this.updateToolbarState();
    },
    updateToolbarState() {
      this.toolbar.forEach(t => {
        if (t.buttons)
          t.buttons.forEach(b => {
            if (b.updateState) b.updateState();
          });
      });
    }
  },
  mounted() {
    this.updateToolbarState();
  },
  async created() {
    const cacheItems = await api.administration.getCaches();
    this.dataSource = new ArrayStore({
      key: "ID",
      data: cacheItems
    });
  }
};
</script>
